import { getWrestlerNameUpper } from './wrestlerUtils';
import React, { useState, useMemo, useEffect, useRef } from 'react';
import ShowFlow from './ShowFlow';
import LogisticsTab, { hasAffordableUpgrade } from './LogisticsTab';
import PLEBookingPage from './PLEBookingPage';
import { ContractExpiryAlert } from './RecruitmentTab';
import HistoryTab from './HistoryTab';
import CareerTab from './CareerTab';
import EndOfSeasonFlow from './EndOfSeasonFlow';
import ShakeUpFlow from './ShakeUpFlow';
import { PLES, getPLELogo } from './plesDatabase';
import { getPLETheme, getPLEBg } from './pleThemes';
import WeekStartPopup from './WeekStartPopup';
import SetChampions from './SetChampions';
import RosterTab from './RosterTab';
import BookingPage from './BookingPage';
import placeholder from '../assets/placeholder.png';
import placeholderTitle from '../assets/Placeholder_Title.png';
import background from '../assets/Background_Test.jpg';
import STORYLINES, { buildVars, resolveText } from './storylinesDatabase';

import gmAdamPearce from '../assets/gm/94400_ADAM_PEARCE.png';
import gmNickAldis from '../assets/gm/121300_NICK_ALDIS.png';
import gmShawnMichaels from '../assets/gm/45750_SHAWN_MICHAELS.png';
import gmAva from '../assets/gm/121400_AVA.png';
import gmStephanie from '../assets/gm/14700_STEPHANIE_MCMAHON.png';
import gmPaulHeyman from '../assets/gm/37410_PAUL_HEYMAN_14.png';
import gmWilliamRegal from '../assets/gm/94010_WILLIAM_REGAL.png';
import gmMickFoley from '../assets/gm/14400_MICK_FOLEY.png';
import gmTeddyLong from '../assets/gm/28600_TEDDY_LONG.png';
import gmEricBischoff from '../assets/gm/93900_ERIC_BISCHOFF.png';
import gmSherri from '../assets/gm/42850_SENSATIONAL_SHERRI.png';
import gmMissElizabeth from '../assets/gm/23450_MISS_ELIZABETH.png';
import gmMrFuji from '../assets/gm/130250_MR_FUJI.png';
import gmBobbyHeenan from '../assets/gm/24900_BOBBY_HENNAN.png';
import gmCMPunk from '../assets/gm/31250_CM_PUNK.png';
import gmXavierWoods from '../assets/gm/42030_XAVIER_WOODS.png';
import gmTylerBreeze from '../assets/gm/58110_TYLER_BREEZE.png';
import gmStacyKeibler from '../assets/gm/148600_STACY_KEIBLER_GM.png';
import gmAnonymousGM from '../assets/gm/149100_ANONYMOUS_GM.png';

import logoRaw from '../assets/brands/logos/RAW25_LOGO.png';
import logoSmackDown from '../assets/brands/logos/SMACKDOWN25_LOGO.png';
import logoNXT from '../assets/brands/logos/NXT_LOGO.png';
import logoNXT20 from '../assets/brands/logos/NXT20_LOGO.png';
import logoWCW from '../assets/brands/logos/WCW_LOGO.png';
import logoECW from '../assets/brands/logos/ECW_LOGO.png';
import logoNXTMutiny from '../assets/brands/logos/NXTMUTINY_LOGO.png';
import bgRaw from '../assets/brands/backgrounds/RAW25_BACKGROUND.png';
import bgSmackDown from '../assets/brands/backgrounds/SMACKDOWN25_BACKGROUND.png';
import bgNXT from '../assets/brands/backgrounds/NXT_BACKGROUND.png';
import bgNXT20 from '../assets/brands/backgrounds/NXT20_BACKGROUND.png';
import bgWCW from '../assets/brands/backgrounds/WCW_BACKGROUND.png';
import bgECW from '../assets/brands/backgrounds/ECW_BACKGROUND.png';
import bgNXTMutiny from '../assets/brands/backgrounds/NXTMUTINY_BACKGROUND.png';


// Dynamic wrestler render loader
const getWrestlerRender = (w) => {
  if (!w) return null;
  if (w.customRender) return w.customRender;
  if (w.wrestler_id) return process.env.PUBLIC_URL + '/wrestlers/' + w.wrestler_id + '-render.png';
  return null;
};

const GM_RENDERS = {
  'Adam Pearce': gmAdamPearce, 'Nick Aldis': gmNickAldis, 'Shawn Michaels': gmShawnMichaels,
  'Ava': gmAva, 'Stephanie McMahon': gmStephanie, 'Paul Heyman': gmPaulHeyman,
  'William Regal': gmWilliamRegal, 'Mick Foley': gmMickFoley, 'Teddy Long': gmTeddyLong,
  'Eric Bischoff': gmEricBischoff, 'Sensational Sherri': gmSherri, 'Miss Elizabeth': gmMissElizabeth,
  'Mr Fuji': gmMrFuji, 'Bobby Heenan': gmBobbyHeenan, 'CM Punk': gmCMPunk,
  'Xavier Woods': gmXavierWoods, 'Tyler Breeze': gmTylerBreeze, 'Stacy Keibler': gmStacyKeibler, 'Anonymous GM': gmAnonymousGM,
};
const BRAND_LOGOS = { 'Raw': logoRaw, 'SmackDown': logoSmackDown, 'NXT': logoNXT, 'NXT 2.0': logoNXT20, 'WCW': logoWCW, 'ECW': logoECW, 'NXT Mutiny': logoNXTMutiny };
const BRAND_BGS = { 'Raw': bgRaw, 'SmackDown': bgSmackDown, 'NXT': bgNXT, 'NXT 2.0': bgNXT20, 'WCW': bgWCW, 'ECW': bgECW, 'NXT Mutiny': bgNXTMutiny };
const BRAND_COLORS = { 'Raw': '#c0392b', 'SmackDown': '#1a6bb5', 'NXT': '#a8a9ad', 'NXT 2.0': '#e91e8c', 'ECW': '#7b1fa2', 'WCW': '#e65100', 'NXT Mutiny': '#424242' };

const css = `
  * { box-sizing: border-box; }
  html { font-size: 133%; }
  .btn-wwe:hover { background: rgba(255,255,255,0.1) !important; border-color: rgba(255,255,255,0.6) !important; color: #fff !important; }
  .nav-tab:hover { color: rgba(255,255,255,0.75) !important; background: rgba(255,255,255,0.04) !important; }
  .nav-tab.active { color: #fff !important; }
  .sub-tab:hover { background: rgba(255,255,255,0.06) !important; color: rgba(255,255,255,0.7) !important; }
  .champ-card:hover { outline: 1.5px solid rgba(255,255,255,0.3) !important; transform: translateY(-2px); }
  .champ-card { transition: border-color 0.15s, transform 0.15s; }
  .rivalry-card:hover { outline: 1.5px solid rgba(255,255,255,0.25) !important; }
  .rivalry-card { transition: border-color 0.15s, background 0.15s; }
  ::-webkit-scrollbar { width: 4px; height: 4px; }
  ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 2px; }
  @keyframes pcOverlayFadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes pcSpotLight { from { opacity: 0; } to { opacity: 1; } }
  @keyframes pcTrophyRise { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pcFadeInUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pcLineExpand { from { transform: scaleX(0); opacity: 0; } to { transform: scaleX(1); opacity: 1; } }
  @keyframes pcTrophyGlow { 0%, 100% { filter: drop-shadow(0 0 18px rgba(212,175,55,0.5)); } 50% { filter: drop-shadow(0 0 36px rgba(212,175,55,0.85)); } }
`;

const S = {
  panel: { background: 'rgba(8,8,8,0.82)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px' },
  title: { fontFamily: "'Anton', sans-serif", letterSpacing: '3px', color: '#fff', textShadow: '0 0 24px rgba(180,0,0,0.4)' },
  sectionTitle: { fontFamily: "'Anton', sans-serif", letterSpacing: '2px', color: '#fff', fontSize: '1rem', textShadow: '0 0 18px rgba(180,0,0,0.3)' },
  mono: { fontFamily: "'Monda', sans-serif" },
  anton: { fontFamily: "'Anton', sans-serif" },
  label: { fontFamily: "'Monda', sans-serif", fontSize: '0.65rem', letterSpacing: '1.5px', color: 'rgba(255,255,255,0.3)' },
};

// Determine week type
const getWeekType = (week) => {
  if (week % 5 === 0) return week === 50 ? 'wrestlemania' : 'ple';
  if (week % 5 === 4) return 'gohome';
  return 'classic';
};

const getWeekTypeLabel = (week) => {
  const type = getWeekType(week);
  if (type === 'wrestlemania') return { label: 'WRESTLEMANIA', color: '#d4af37' };
  if (type === 'ple') return { label: 'PLE', color: '#9b59b6' };
  if (type === 'gohome') return { label: 'GO-HOME SHOW', color: '#e67e22' };
  return { label: 'WEEKLY SHOW', color: '#3498db' };
};

const getNextEvent = (week) => {
  // Next PLE
  const nextPLE = Math.ceil(week / 5) * 5;
  const weeksLeft = nextPLE - week;
  const isGoHome = week % 5 === 4;
  const isPLE = week % 5 === 0;
  return { nextPLE, weeksLeft, isGoHome, isPLE };
};

const formatBudget = (val) => {
  if (!val) return '$0';
  return '$' + Math.round(Number(val)).toLocaleString('fr-FR');
};

const formatFans = (val) => {
  if (val === undefined || val === null) return '0';
  return Math.round(Number(val)).toLocaleString('fr-FR');
};

// ── Placeholder data ────────────────────────────────────────────────
const PLACEHOLDER_CHAMPIONS = [
  { key: 'male-world', label: 'World Title', champion: null, titleRender: null, isTagTeam: false },
  { key: 'male-minor', label: 'Minor Title', champion: null, titleRender: null, isTagTeam: false },
  { key: 'female-world', label: "Women's World Title", champion: null, titleRender: null, isTagTeam: false },
  { key: 'female-minor', label: "Women's Minor Title", champion: null, titleRender: null, isTagTeam: false },
  { key: 'tagteam-male', label: 'Tag Team Title', champion: null, titleRender: null, isTagTeam: true },
  { key: 'tagteam-female', label: "Women's Tag Team", champion: null, titleRender: null, isTagTeam: true },
];

const PLACEHOLDER_RIVALRIES = [
  { id: 1, superstar1: null, superstar2: null, title: null, weeks: 0 },
  { id: 2, superstar1: null, superstar2: null, title: null, weeks: 0 },
  { id: 3, superstar1: null, superstar2: null, title: null, weeks: 0 },
];

const PLACEHOLDER_LAST_WEEK = [
  { match: 'Match 1', result: null, note: null },
  { match: 'Match 2', result: null, note: null },
  { match: 'Match 3', result: null, note: null },
];

// ── Championship Card ───────────────────────────────────────────────
const ChampCard = ({ champ, brandColor }) => {
  const hasChamp = champ.champion && champ.champion.length > 0;
  return (
    <div className="champ-card" style={{ ...S.panel, padding: '10px 10px 8px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', outline: '1px solid transparent', cursor: 'default', minWidth: champ.isTagTeam ? '160px' : '120px', flex: 1 }}>
      <img loading="lazy" src={champ.titleRender || placeholderTitle} alt="" style={{ height: '60px', objectFit: 'contain', filter: `drop-shadow(0 2px 8px rgba(212,175,55,${hasChamp ? '0.5' : '0.2'}))` }} />
      {hasChamp ? (
        <>
          {champ.isTagTeam ? (
            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center', position: 'relative', height: '110px', width: '100%' }}>
              <img loading="lazy" src={getWrestlerRender(champ.champion[0]) || placeholder} alt=""
                style={{ height: '100px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))', position: 'absolute', left: '5%', transform: 'rotate(-4deg)', zIndex: 1 }} />
              <img loading="lazy" src={getWrestlerRender(champ.champion[1]) || placeholder} alt=""
                style={{ height: '100px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))', position: 'absolute', right: '5%', transform: 'rotate(4deg)', zIndex: 2 }} />
            </div>
          ) : (
            <img loading="lazy" src={getWrestlerRender(champ.champion[0]) || placeholder} alt=""
              style={{ height: '100px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.8))' }} />
          )}
          <div style={{ textAlign: 'center' }}>
            <div style={{ ...S.mono, fontSize: '0.55rem', color: '#d4af37', textAlign: 'center', lineHeight: '1.3' }}>
              {champ.isTagTeam
                ? <>{getWrestlerNameUpper(champ.champion[0], 'display')}<br/>&amp; {getWrestlerNameUpper(champ.champion[1], 'display')}</>
                : getWrestlerNameUpper(champ.champion[0], 'display')}
            </div>
            <div style={{ ...S.label, fontSize: '0.48rem' }}>{champ.label}</div>
          </div>
        </>
      ) : (
        <>
          <div style={{ height: '52px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ ...S.mono, fontSize: '0.72rem', color: 'rgba(255,255,255,0.2)' }}>VACANT</div>
          </div>
          <div style={{ ...S.label, fontSize: '0.36rem', textAlign: 'center' }}>{champ.label}</div>
        </>
      )}
    </div>
  );
};

// ── Rivalry Card ────────────────────────────────────────────────────
const RIVALRY_LEVEL_COLORS_D = { 1: '#3498db', 2: '#e67e22', 3: '#e74c3c', 4: '#d4af37' };
const RIVALRY_LEVEL_LABELS_D = { 1: 'Lv.1 - Beginning', 2: 'Lv.2 - Intense', 3: 'Lv.3 - Heated', 4: 'Lv.4 - Blood Feud' };

const RivalryCard = ({ rivalry, roster, brandColor }) => {
  var roster_ = roster || [];
  var side1Members = [];
  var side2Members = [];

  if (rivalry.side1 && Array.isArray(rivalry.side1)) {
    side1Members = rivalry.side1.map(id => {
      var w = roster_.find(w => w.wrestler_id === id || w.wrestler_id === Number(id));
      if (w) return w;
      // Fallback to snapshot
      var snap = (rivalry.side1Snapshot || []).find(s => String(s.wrestler_id) === String(id));
      return snap ? { ...snap, customRender: snap.render, _isSnapshot: true } : null;
    }).filter(Boolean);
    side2Members = rivalry.side2 ? rivalry.side2.map(id => {
      var w = roster_.find(w => w.wrestler_id === id || w.wrestler_id === Number(id));
      if (w) return w;
      var snap = (rivalry.side2Snapshot || []).find(s => String(s.wrestler_id) === String(id));
      return snap ? { ...snap, customRender: snap.render, _isSnapshot: true } : null;
    }).filter(Boolean) : [];
  } else if (rivalry.superstar1) {
    side1Members = rivalry.superstar1 ? [rivalry.superstar1] : [];
    side2Members = rivalry.superstar2 ? [rivalry.superstar2] : [];
  }

  const lvlColor = RIVALRY_LEVEL_COLORS_D[rivalry.level] || '#e74c3c';
  const lvlLabel = RIVALRY_LEVEL_LABELS_D[rivalry.level] || '';
  const RENDER_W = 140;
  const RENDER_H = 170;
  var totalW = (side1Members.length + side2Members.length) * RENDER_W + 32 + (side1Members.length + side2Members.length - 1) * 6 + 24;

  // Storyline narrative display
  var storyId = rivalry.storylineId;
  var storyLine = storyId ? STORYLINES.find(s => s.id === storyId) : null;
  var currentPhase = storyLine ? storyLine.phases.find(p => p.level === (rivalry.level || 1)) : null;
  var storyText = null;
  if (currentPhase && currentPhase.variants && currentPhase.variants.length > 0) {
    var vars = buildVars(rivalry, roster_);
    var varIdx = (rivalry.storylineVariantByLevel && rivalry.storylineVariantByLevel[rivalry.level]) || 0;
    storyText = resolveText(currentPhase.variants[varIdx % currentPhase.variants.length], vars);
  }

  return (
    <div style={{ ...S.panel, overflow: 'hidden', border: '1px solid ' + lvlColor + '33', position: 'relative', display: 'flex', flexDirection: 'column', width: totalW + 'px', flexShrink: 0 }}>
      {/* Level bar */}
      <div style={{ height: '3px', background: 'linear-gradient(90deg, transparent, ' + lvlColor + ', transparent)', flexShrink: 0 }} />

      {/* Level badge + weeks */}
      <div style={{ padding: '8px 12px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexShrink: 0 }}>
        <div style={{ ...S.mono, fontSize: '0.44rem', color: lvlColor, background: lvlColor + '18', border: '1px solid ' + lvlColor + '44', borderRadius: '3px', padding: '2px 8px', letterSpacing: '1px' }}>
          {lvlLabel}
        </div>
        {rivalry.weeks > 0 && (
          <div style={{ ...S.mono, fontSize: '0.4rem', color: 'rgba(255,255,255,0.3)' }}>W{rivalry.weeks}</div>
        )}
      </div>

      {/* Renders row — fixed size per wrestler, card width adapts */}
      <div style={{ display: 'flex', alignItems: 'flex-end', padding: '8px 12px 0', gap: '6px', flexShrink: 0 }}>
        {/* Side 1 */}
        {side1Members.map(function(w, i) { return (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt=""
              style={{ width: RENDER_W + 'px', height: RENDER_H + 'px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.9))' }} />
          </div>
        ); })}

        {/* VS */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', paddingBottom: '28px', flexShrink: 0, width: '32px' }}>
          <div style={{ ...S.anton, fontSize: '0.9rem', color: '#e74c3c' }}>VS</div>
        </div>

        {/* Side 2 */}
        {side2Members.map(function(w, i) { return (
          <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt=""
              style={{ width: RENDER_W + 'px', height: RENDER_H + 'px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.9))' }} />
          </div>
        ); })}
      </div>

      {/* Names */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '4px 12px 12px', gap: '6px' }}>
        <div style={{ display: 'flex', gap: '6px' }}>
          {side1Members.map(function(w, i) { return (
            <div key={i} style={{ width: RENDER_W + 'px', textAlign: 'center', ...S.anton, fontSize: '0.5rem', color: '#fff', letterSpacing: '0.5px', lineHeight: '1.2' }}>
              {getWrestlerNameUpper(w, 'display')}
            </div>
          ); })}
        </div>
        <div style={{ width: '32px', flexShrink: 0 }} />
        <div style={{ display: 'flex', gap: '6px' }}>
          {side2Members.map(function(w, i) { return (
            <div key={i} style={{ width: RENDER_W + 'px', textAlign: 'center', ...S.anton, fontSize: '0.5rem', color: '#fff', letterSpacing: '0.5px', lineHeight: '1.2' }}>
              {getWrestlerNameUpper(w, 'display')}
            </div>
          ); })}
        </div>
      </div>

      {/* Storyline narrative */}
      {storyLine && storyText && (
        <div style={{ padding: '0 12px 12px', borderTop: '1px solid rgba(155,89,182,0.15)' }}>
          <div style={{ padding: '10px 12px', background: 'rgba(155,89,182,0.06)', border: '1px solid rgba(155,89,182,0.2)', borderRadius: '6px', marginTop: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
              <span style={{ fontSize: '0.7rem' }}>{storyLine.icon}</span>
              <div style={{ ...S.anton, fontSize: '0.55rem', letterSpacing: '2px', color: '#9b59b6' }}>{storyLine.name.toUpperCase()}</div>
              {currentPhase && <div style={{ ...S.mono, fontSize: '0.36rem', color: 'rgba(155,89,182,0.6)', letterSpacing: '1px' }}>· {currentPhase.name.toUpperCase()}</div>}
            </div>
            <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.65)', fontStyle: 'italic', lineHeight: 1.6 }}>"{storyText}"</div>
          </div>
        </div>
      )}
    </div>
  );
};

// ── HOF Trophy Toast ────────────────────────────────────────────────
const HOF_TOAST_CSS = `
@keyframes toastSlideIn {
  from { transform: translateX(120%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}
@keyframes toastSlideOut {
  from { transform: translateX(0);    opacity: 1; }
  to   { transform: translateX(120%); opacity: 0; }
}
@keyframes toastDrain {
  from { width: 100%; }
  to   { width: 0%; }
}
`;

const trophyToastAsset = process.env.PUBLIC_URL + '/hof/trophy.png';

// ── HOF Goal Reached — Press Conference ──────────────────────────────
const trophyPCAsset = process.env.PUBLIC_URL + '/hof/trophy.png';

const HOFGoalReachedAnimation = ({ goal, gmName, onComplete }) => {
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 600);
    }, 7000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  if (!visible) return null;

  var displayName = gmName ? gmName.toUpperCase() : 'GM';

  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 9999, background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', animation: 'pcOverlayFadeIn 0.6s ease-out' }}
      onClick={() => { setVisible(false); setTimeout(onComplete, 200); }}
    >
      <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '340px', height: '100%', background: 'radial-gradient(ellipse 170px 60% at 50% 0%, rgba(212,175,55,0.18) 0%, rgba(212,175,55,0.06) 50%, transparent 80%)', animation: 'pcSpotLight 1.6s ease-out 0.2s both', pointerEvents: 'none' }} />
      <div style={{ position: 'relative', zIndex: 2, textAlign: 'center', padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', letterSpacing: '4px', color: 'rgba(212,175,55,0.75)', marginBottom: '10px', animation: 'pcFadeInUp 0.7s ease-out 0.3s both' }}>
          CONGRATULATIONS,&nbsp;<span style={{ color: '#d4af37', fontWeight: 700 }}>{displayName}</span>
        </div>
        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.45rem', letterSpacing: '3px', color: 'rgba(255,255,255,0.4)', marginBottom: '44px', animation: 'pcFadeInUp 0.7s ease-out 0.55s both' }}>
          YOU'VE REACHED YOUR HALL OF FAME GOAL
        </div>
        <div style={{ marginBottom: '40px', animation: 'pcTrophyRise 1s cubic-bezier(0.22, 1, 0.36, 1) 0.8s both' }}>
          <img src={trophyPCAsset} alt="" style={{ width: '200px', height: '200px', objectFit: 'contain', animation: 'pcTrophyGlow 2.5s ease-in-out 1.8s infinite' }} onError={e => { e.target.style.display = 'none'; }} />
        </div>
        <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '2.6rem', letterSpacing: '10px', color: '#fff', animation: 'pcFadeInUp 0.8s ease-out 1.6s both' }}>
          HALL OF FAME
        </div>
        <div style={{ width: '120px', height: '1px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)', margin: '16px auto', animation: 'pcLineExpand 0.6s ease-out 2s both', transformOrigin: 'center' }} />
        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.5rem', letterSpacing: '5px', color: '#d4af37', marginBottom: '6px', animation: 'pcFadeInUp 0.6s ease-out 2.2s both' }}>
          GOAL ACHIEVED
        </div>
        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.45rem', letterSpacing: '4px', color: 'rgba(255,255,255,0.35)', animation: 'pcFadeInUp 0.6s ease-out 2.5s both' }}>
          SEASON COMPLETE
        </div>
        <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.4rem', letterSpacing: '2px', color: 'rgba(255,255,255,0.2)', marginTop: '52px', animation: 'pcFadeInUp 0.6s ease-out 3.2s both' }}>
          CLICK ANYWHERE TO CONTINUE
        </div>
      </div>
    </div>
  );
};

const HOFTrophyToast = ({ queue, onDismiss }) => {
  const [exiting, setExiting] = React.useState(false);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    if (queue.length === 0) return;
    setExiting(false);
    timerRef.current = setTimeout(() => {
      setExiting(true);
      setTimeout(onDismiss, 380);
    }, 3800);
    return () => clearTimeout(timerRef.current);
  }, [queue.length > 0 ? queue[0].name : null]);

  if (queue.length === 0) return null;

  var item = queue[0];
  var isFans = item.type === 'fans';
  var accentColor = isFans ? '#3498db' : '#2ecc71';

  return (
    <>
      <style>{HOF_TOAST_CSS}</style>
      <div
        onClick={() => { clearTimeout(timerRef.current); setExiting(true); setTimeout(onDismiss, 380); }}
        style={{
          position: 'fixed', bottom: '28px', right: '24px', zIndex: 99999,
          width: '280px',
          background: '#111',
          borderLeft: '3px solid ' + accentColor,
          borderRadius: '0 8px 8px 0',
          padding: '12px 14px',
          display: 'flex', alignItems: 'center', gap: '12px',
          cursor: 'pointer',
          animation: exiting
            ? 'toastSlideOut 0.38s cubic-bezier(0.55,0,1,0.45) forwards'
            : 'toastSlideIn 0.4s cubic-bezier(0.22,1,0.36,1) forwards',
        }}
      >
        <img
          src={trophyToastAsset} alt=""
          style={{ width: '36px', height: '36px', objectFit: 'contain', flexShrink: 0, filter: 'drop-shadow(0 0 8px ' + accentColor + '88)' }}
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.42rem', letterSpacing: '3px', color: accentColor, marginBottom: '3px' }}>
            HOF TROPHY UNLOCKED
          </div>
          <div style={{ fontFamily: "'Anton', sans-serif", fontSize: '0.9rem', letterSpacing: '2px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {item.name.toUpperCase()}
          </div>
          <div style={{ fontFamily: "'Monda', sans-serif", fontSize: '0.38rem', letterSpacing: '2px', color: 'rgba(255,255,255,0.3)', marginTop: '2px' }}>
            {isFans ? 'FAN MILESTONE' : 'PROFIT MILESTONE'}
          </div>
          <div style={{ height: '2px', background: 'rgba(255,255,255,0.08)', borderRadius: '1px', marginTop: '7px', overflow: 'hidden' }}>
            <div style={{ height: '100%', background: accentColor, borderRadius: '1px', animation: 'toastDrain 3.8s linear forwards' }} />
          </div>
        </div>
      </div>
    </>
  );
};

// ── MAIN ────────────────────────────────────────────────────────────
export default function Dashboard({ gameData, onBack, activeTab: activeTabProp, setActiveTab: setActiveTabProp, onUpdateGame, showWeekStart: showWeekStartProp, onCloseWeekStart, confirmDestructive }) {
  const brand = gameData?.brand || 'Raw';
  const gm = gameData?.gm || '';
  const week = gameData?.week || 1;
  const budget = gameData?.budget || gameData?.gameSettingsData?.budget || 3000000;
  const fans = gameData?.fans ?? 1000000;
  const hofGoal = gameData?.hofTrophies ?? gameData?.gameSettingsData?.hofTrophies ?? 10;
  const hofActive = gameData?.hofActive || [];
  // Auto fan trophies
  const AUTO_FAN_THRESHOLDS = [2300000, 3400000, 4500000, 5250000, 6000000];
  const AUTO_PROFIT_THRESHOLDS = [2000000, 5250000, 8750000, 12500000, 16000000];
  const { totalProfits, autoFanCount, autoProfitCount, hofTrophies, hofTotal } = useMemo(() => {
    const totalProfits = (gameData?.seasonHistory || []).reduce((s, w) => s + (w.profits || 0), 0);
    const autoFanCount = AUTO_FAN_THRESHOLDS.filter(t => fans >= t).length;
    const autoProfitCount = AUTO_PROFIT_THRESHOLDS.filter(t => totalProfits >= t).length;
    const hofTrophies = hofActive.length + autoFanCount + autoProfitCount;
    const hofTotal = hofGoal + AUTO_FAN_THRESHOLDS.length + AUTO_PROFIT_THRESHOLDS.length;
    return { totalProfits, autoFanCount, autoProfitCount, hofTrophies, hofTotal };
  }, [gameData?.seasonHistory, fans, hofActive, hofGoal]);
  const victoryCriteria = gameData?.victoryCriteria || gameData?.gameSettingsData?.victoryCriteria || 'fans';
  const rivals = gameData?.rivals || [];
  const championsRaw = gameData?.champions || {};
  // champions can be { slots, champions } from SetChampions or direct object
  const championsMap = championsRaw?.champions || championsRaw;

  const brandColor = BRAND_COLORS[brand] || gameData?.brandColor || '#d4af37';
  const brandLogo = BRAND_LOGOS[brand] || gameData?.brandLogo || null;
  const brandBg = BRAND_BGS[brand] || gameData?.brandBg || null;
  const gmRender = GM_RENDERS[gm] || gameData?.gmRender || null;

  // PLE / Go-Home theming
  const isPLEWeek = week % 5 === 0;
  const isGoHomeWeek = week % 5 === 4;
  // Force WrestleMania from week 46 onwards
  const nextPleId = week >= 46 ? 'wrestlemania' : (gameData?.nextPle || null);
  const pleTheme = nextPleId ? getPLETheme(nextPleId) : null;
  const pleBgUrl = nextPleId ? getPLEBg(nextPleId) : null;
  const pleAccentColor = (pleTheme && pleTheme.color) || brandColor;
  const pleColor = isPLEWeek ? pleAccentColor : brandColor;
  const goHomeColor = '#e67e22';
  const pleLogo = nextPleId ? getPLELogo(nextPleId) : null;
  const pleData = nextPleId ? PLES.find(p => p.id === nextPleId) : null;

  const weekTypeInfo = getWeekTypeLabel(week);
  const { nextPLE, weeksLeft } = getNextEvent(week);
  const nextGoHome = nextPLE - 1;
  const weeksToGoHome = nextGoHome - week;

  // Check if all match slots are booked
  const isBookingComplete = useMemo(() => {
    if (week % 5 === 0) return !!(gameData && gameData.bookingFinished);
    const bookingSlots = gameData?.bookingSlots || [];
    const matchSlots = bookingSlots.filter(s => s.type !== 'promo');
    return matchSlots.length > 0 && matchSlots.every(s => s.booking && s.booking.participants && s.booking.participants.length > 0);
  }, [week, gameData?.bookingFinished, gameData?.bookingSlots]);

  // Total show cost and budget check
  const totalShowCost = useMemo(() => {
    const bookingSlots = gameData?.bookingSlots || [];
    return bookingSlots.reduce((sum, s) => sum + (s.booking?.cost || 0), 0);
  }, [gameData?.bookingSlots]);
  const isOverBudget = isBookingComplete && totalShowCost > budget;

  const lastWeekMatches = gameData?.lastWeek || PLACEHOLDER_LAST_WEEK;
  const rivalries = gameData?.rivalries || PLACEHOLDER_RIVALRIES;
  const [localTab, setLocalTab] = useState(gameData && gameData._forceHomeTab ? 'home' : (activeTabProp || 'home'));
  const [showWeekStart, setShowWeekStart] = useState(showWeekStartProp !== false);
  const [showSetChampions, setShowSetChampions] = useState(false);
  const [showFlow, setShowFlow] = useState(false);
  const [confirmStopShow, setConfirmStopShow] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(null);
  const [showContractAlert, setShowContractAlert] = useState(false);
  const [contractAlertGame, setContractAlertGame] = useState(null);
  const [showEndOfSeason, setShowEndOfSeason] = useState(!!(gameData && gameData._endOfSeason));
  const [showShakeUp, setShowShakeUp] = useState(false);
  const activeTab = activeTabProp ?? localTab;
  const setActiveTab = setActiveTabProp ?? setLocalTab;
  const [rosterSubTab, setRosterSubTab] = useState('CURRENT ROSTER');
  const [showRosterMenu, setShowRosterMenu] = useState(false);

  // ── HOF Toast — détection auto-trophées ──────────────────────────
  const [toastQueue, setToastQueue] = useState([]);
  const prevAutoRef = useRef({ fans: -1, profits: -1 });
  const [showHofGoalReached, setShowHofGoalReached] = useState(false);
  const hofGoalReachedRef = useRef(false);

  const AUTO_FAN_TROPHY_NAMES = ['2.3M Fans', '3.4M Fans', '4.5M Fans', '5.25M Fans', '6M Fans'];
  const AUTO_PROFIT_TROPHY_NAMES = ['2M Profits', '5.25M Profits', '8.75M Profits', '12.5M Profits', '16M Profits'];

  useEffect(() => {
    var curFan = AUTO_FAN_THRESHOLDS.filter(t => fans >= t).length;
    var curProfit = AUTO_PROFIT_THRESHOLDS.filter(t => totalProfits >= t).length;
    // Premier render — initialiser sans animer
    if (prevAutoRef.current.fans === -1) {
      prevAutoRef.current = { fans: curFan, profits: curProfit };
      return;
    }
    var newItems = [];
    if (curFan > prevAutoRef.current.fans) {
      for (var i = prevAutoRef.current.fans; i < curFan; i++) {
        newItems.push({ name: AUTO_FAN_TROPHY_NAMES[i], type: 'fans' });
      }
    }
    if (curProfit > prevAutoRef.current.profits) {
      for (var j = prevAutoRef.current.profits; j < curProfit; j++) {
        newItems.push({ name: AUTO_PROFIT_TROPHY_NAMES[j], type: 'profits' });
      }
    }
    if (newItems.length > 0) {
      setToastQueue(prev => [...prev, ...newItems]);
    }
    prevAutoRef.current = { fans: curFan, profits: curProfit };

    // Détection goal HOF global — déclenche l'animation Press Conference
    var currentManual = (gameData?.hofActive || []).length;
    var totalTrophies = Math.min(currentManual + curFan + curProfit, hofGoal);
    // Persist "already shown" via Firestore — résiste aux rechargements et clear sessionStorage
    var alreadyShown = gameData?.hofGoalAnimShown === true;
    // Si les trophées redescendent sous le goal (trophée retiré), on reset le flag Firestore
    if (totalTrophies < hofGoal && alreadyShown) {
      if (onUpdateGame) onUpdateGame({ ...gameData, hofGoalAnimShown: false });
      hofGoalReachedRef.current = false;
    }
    if (totalTrophies >= hofGoal && !hofGoalReachedRef.current && !alreadyShown) {
      hofGoalReachedRef.current = true;
      if (onUpdateGame) onUpdateGame({ ...gameData, hofGoalAnimShown: true });
      setTimeout(() => setShowHofGoalReached(true), 800);
    }
  }, [fans, totalProfits, gameData?.hofActive]);

  // Build champ list from saved champions
  const champList = useMemo(() => {
    const slots = championsRaw?.slots || [];
    if (slots.length > 0) {
      return slots.map(slot => {
        const saved = championsMap[slot.key];
        return {
          key: slot.key,
          label: slot.titleOverride?.name || slot.label || slot.key,
          champion: saved || null,
          titleRender: slot.titleOverride?.render || null,
          isTagTeam: slot.isTagTeam || false,
        };
      });
    }
    return PLACEHOLDER_CHAMPIONS.map(c => {
      const saved = championsMap[c.key];
      const slot = slots.find(s => s.key === c.key);
      return { ...c, champion: saved || null, titleRender: slot?.titleOverride?.render || null, label: slot?.titleOverride?.name || slot?.label || c.label };
    });
  }, [championsMap, championsRaw]);

  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <style>{css}</style>
      {/* HOF Trophy Toast — auto milestones */}
      <HOFTrophyToast
        queue={toastQueue}
        onDismiss={() => setToastQueue(prev => prev.slice(1))}
      />
      {/* HOF Goal Reached — Press Conference */}
      {showHofGoalReached && (
        <HOFGoalReachedAnimation
          goal={hofGoal}
          gmName={gm}
          onComplete={() => setShowHofGoalReached(false)}
        />
      )}
      {showWeekStart && (
        <WeekStartPopup
          gameData={{
            ...gameData,
            brandColor,
            brandLogo,
            brandBg,
            _onUpdateGame: onUpdateGame,
          }}
          onStartWeek={({ nextPle, budget }) => {
            setShowWeekStart(false);
            if (onCloseWeekStart) onCloseWeekStart();
            // Reset shakeUpDone flag if not on a post-PLE week
            const currentWeek = (gameData && gameData.week) || 1;
            const prevWeek = currentWeek - 1;
            const wasPLEWeek = prevWeek > 0 && prevWeek % 5 === 0 && prevWeek < 50;
            var updatedGame = { ...gameData, nextPle, ...(budget !== undefined ? { budget } : {}) };
            if (!wasPLEWeek) {
              updatedGame._shakeUpDone = false;
            }
            if (onUpdateGame) onUpdateGame(updatedGame);
            // Trigger SetChampions if this is a new game
            if (gameData._pendingSetChampions) {
              setShowSetChampions(true);
            }
            // Check contract expiries for the NEW week
            var newWeek = gameData.week || 1;
            var expiring = (updatedGame.roster || []).filter(function(w) { return w.contractEnd && Number(w.contractEnd) === Number(newWeek); });
            if (expiring.length > 0) {
              setContractAlertGame(updatedGame);
              setShowContractAlert(true);
            }
          }}
        />
      )}
      {/* Set Champions — shown after WeekStart on new game */}
      {showSetChampions && (
        <SetChampions
          brand={gameData.brand}
          roster={gameData.roster || []}
          customTitleOverrides={gameData.brandIsCustom ? (gameData.champions?.customOverrides || null) : null}
          onBack={() => { setShowSetChampions(false); setShowWeekStart(true); }}
          onConfirm={(champions) => {
            setShowSetChampions(false);
            var updatedGame = { ...gameData, champions, _pendingSetChampions: false };
            if (onUpdateGame) onUpdateGame(updatedGame);
          }}
        />
      )}
      {/* Shake-Up Flow (after PLE) */}
      {showShakeUp && (
        <ShakeUpFlow
          gameData={gameData}
          onComplete={(updatedGame) => {
            setShowShakeUp(false);
            if (onUpdateGame) onUpdateGame(updatedGame);
            setShowWeekStart(true);
          }}
          onSkip={() => {
            setShowShakeUp(false);
            // Mark as done so we don't trigger again
            if (onUpdateGame) onUpdateGame({ ...gameData, _shakeUpDone: true });
            setShowWeekStart(true);
          }}
        />
      )}

      {/* End of Season Flow */}
      {showEndOfSeason && (
        <EndOfSeasonFlow
          gameData={gameData}
          onUpdateGame={onUpdateGame}
          onComplete={(updatedGame) => {
            setShowEndOfSeason(false);
            if (onUpdateGame) onUpdateGame(updatedGame);
            setShowWeekStart(true);
          }}
        />
      )}

      {/* Contract Expiry Alert */}
      {showContractAlert && contractAlertGame && (
        <ContractExpiryAlert
          expiring={(contractAlertGame.roster || []).filter(function(w) { return w.contractEnd && Number(w.contractEnd) === Number(contractAlertGame.week); })}
          week={contractAlertGame.week}
          budget={contractAlertGame.budget || 0}
          brandColor={brandColor}
          onRenew={(wrestler, price, duration) => {
            var currentWeek = contractAlertGame.week;
            var newRoster = (contractAlertGame.roster || []).map(function(w) {
              if (w.wrestler_id !== wrestler.wrestler_id) return w;
              return { ...w, contractEnd: currentWeek + duration, contractStart: currentWeek };
            });
            var newBudget = (contractAlertGame.budget || 0) - price;
            var updated = { ...contractAlertGame, roster: newRoster, budget: newBudget };
            setContractAlertGame(updated);
            if (onUpdateGame) onUpdateGame(updated);
            // Check remaining expiries with updated roster
            var remaining = newRoster.filter(function(w) { return w.contractEnd && Number(w.contractEnd) === Number(currentWeek); });
            if (remaining.length === 0) setShowContractAlert(false);
          }}
          onRelease={(wrestler) => {
            var currentWeek = contractAlertGame.week;
            // Mark as releasing — stays for this week, removed after show
            var newRoster = (contractAlertGame.roster || []).map(function(w) {
              if (w.wrestler_id !== wrestler.wrestler_id) return w;
              return { ...w, releasing: true };
            });
            var updated = { ...contractAlertGame, roster: newRoster };
            setContractAlertGame(updated);
            if (onUpdateGame) onUpdateGame(updated);
            var remaining = newRoster.filter(function(w) { return w.contractEnd && Number(w.contractEnd) === Number(currentWeek) && !w.releasing; });
            if (remaining.length === 0) setShowContractAlert(false);
          }}
          onClose={() => setShowContractAlert(false)}
        />
      )}

      {/* Backgrounds */}
      <img loading="lazy" src={background} alt="" style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }} />
      {/* Brand bg */}
      {brandBg && !isPLEWeek && <img loading="lazy" src={brandBg} alt="" style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.18, zIndex: 1 }} />}
      {/* PLE bg */}
      {isPLEWeek && pleBgUrl && <img loading="lazy" src={pleBgUrl} alt="" style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.25, zIndex: 1 }} onError={e => { e.target.style.display='none'; }} />}
      {isPLEWeek && <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse at 50% 30%, ' + pleColor + '18 0%, transparent 60%)', zIndex: 2, pointerEvents: 'none' }} />}
      {/* Go-Home accent */}
      {/* Go-Home background — dark arena texture via CSS */}
      {isGoHomeWeek && (
        <>
          {/* Dark base overlay stronger than normal */}
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1, pointerEvents: 'none' }} />
          {/* Subtle grid texture */}
          <div style={{ position: 'fixed', inset: 0, zIndex: 1, pointerEvents: 'none', backgroundImage: 'linear-gradient(rgba(230,126,34,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(230,126,34,0.04) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
          {/* Orange spotlight from top */}
          <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse at 50% -10%, rgba(230,126,34,0.22) 0%, rgba(230,126,34,0.08) 35%, transparent 65%)', zIndex: 2, pointerEvents: 'none' }} />
          {/* Vignette */}
          <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.7) 100%)', zIndex: 2, pointerEvents: 'none' }} />
          {/* PLE logo watermark */}
          {pleLogo && <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2, opacity: 0.03, pointerEvents: 'none', filter: 'blur(2px)' }}>
            <img loading="lazy" src={pleLogo} alt="" style={{ height: '500px', objectFit: 'contain' }} />
          </div>}
        </>
      )}
      <div style={{ position: 'fixed', inset: 0, background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.85) 100%)', zIndex: 2 }} />

      {/* Over-budget warning banner — floats over content, doesn't push layout */}
      {isOverBudget && !showFlow && (
        <div style={{ position: 'fixed', top: '91px', left: '50%', transform: 'translateX(-50%)', zIndex: 200, display: 'flex', alignItems: 'center', gap: '8px', background: 'rgba(12,4,4,0.96)', border: '1px solid rgba(231,76,60,0.5)', borderRadius: '6px', padding: '6px 16px', pointerEvents: 'none', whiteSpace: 'nowrap', boxShadow: '0 2px 16px rgba(231,76,60,0.25)' }}>
          <span style={{ color: '#e74c3c', fontSize: '0.5rem', fontFamily: "'Anton',sans-serif", letterSpacing: '1.5px' }}>⚠ INSUFFICIENT BUDGET</span>
          <span style={{ color: 'rgba(231,76,60,0.7)', fontSize: '0.44rem', fontFamily: "'Monda',sans-serif" }}>— Show cost (${totalShowCost.toLocaleString('en-US')}) exceeds available budget (${budget.toLocaleString('en-US')}). Reduce match costs to run the show.</span>
        </div>
      )}

      {/* Tab bar */}
      <div style={{ position: 'fixed', top: '49px', left: 0, right: 0, zIndex: 49, display: 'flex', justifyContent: 'center', gap: '0', borderBottom: '1px solid rgba(255,255,255,0.08)', background: 'rgba(6,6,6,0.98)', backdropFilter: 'blur(4px)' }}>
        {[
          { key: 'home', label: 'HOME' },
          { key: 'booking', label: 'BOOKING' },
          { key: 'roster', label: 'ROSTER', subs: ['CURRENT ROSTER', 'RIVALRIES', 'CHAMPIONSHIPS', 'RECRUITMENT'] },
          { key: 'logistics', label: 'LOGISTICS', showStar: hasAffordableUpgrade(gameData) },
          { key: 'carriere', label: 'CAREER' },
          { key: 'history', label: 'HISTORY' },
          { key: 'run-show', label: '▶ RUN SHOW', special: true },
        ].map(tab => {
          const isRunShow = tab.key === 'run-show';
          const tabColor = isRunShow
            ? (isOverBudget ? '#e74c3c' : isBookingComplete ? '#2ecc71' : 'rgba(255,255,255,0.2)')
            : (activeTab === tab.key ? '#fff' : 'rgba(255,255,255,0.35)');
          const isHovered = hoveredTab === tab.key;
          const showDropdown = tab.subs && isHovered;

          return (
            <div key={tab.key} style={{ position: 'relative' }}
              onMouseEnter={() => setHoveredTab(tab.key)}
              onMouseLeave={() => setHoveredTab(null)}>
              <button
                className={`nav-tab${activeTab === tab.key ? ' active' : ''}`}
                onClick={() => {
                  // During show flow — HOME opens stop confirmation, everything else is locked
                  if (showFlow) {
                    if (tab.key === 'home') setConfirmStopShow(true);
                    return;
                  }
                  if (isRunShow) { if (isBookingComplete && !isOverBudget) { setShowFlow(true); } return; }
                  setActiveTab(tab.key);
                  if (tab.key === 'roster') setRosterSubTab(null);
                  setShowRosterMenu(false);
                }}
                style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.58rem', letterSpacing: '1.5px', background: activeTab === tab.key ? 'rgba(255,255,255,0.05)' : 'transparent', border: 'none', borderBottom: `2px solid ${activeTab === tab.key ? (isPLEWeek ? pleAccentColor : isGoHomeWeek ? goHomeColor : brandColor) : isRunShow && isOverBudget ? '#e74c3c' : isRunShow && isBookingComplete ? '#2ecc71' : 'transparent'}`, color: showFlow ? (tab.key === 'home' ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.15)') : tabColor, padding: '10px 28px', cursor: showFlow ? (tab.key === 'home' ? 'pointer' : 'not-allowed') : (isRunShow && (!isBookingComplete || isOverBudget) ? 'not-allowed' : 'pointer'), transition: 'background 0.15s, border-color 0.15s, color 0.15s', whiteSpace: 'nowrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  {tab.label}
                  {tab.showStar && <img loading="lazy" src={process.env.PUBLIC_URL + '/icons/star-full.png'} alt="" style={{ width: '15px', height: '15px', objectFit: 'contain', verticalAlign: 'middle' }} onError={e => { e.target.style.display='none'; }} />}
                  {tab.subs ? ' ▾' : ''}
                </span>
              </button>

              {/* Hover dropdown for tabs with submenus — hidden during showFlow */}
              {showDropdown && !showFlow && (
                <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', background: 'rgba(8,8,8,0.98)', border: '1px solid rgba(255,255,255,0.1)', borderTop: `2px solid ${brandColor}`, borderRadius: '0 0 8px 8px', display: 'flex', flexDirection: 'column', zIndex: 50, minWidth: '200px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.8)' }}>
                  {tab.subs.map(sub => (
                    <button key={sub}
                      onClick={() => { setActiveTab(tab.key); setRosterSubTab(sub); setHoveredTab(null); }}
                      onMouseEnter={e => { e.currentTarget.style.background = brandColor + '15'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderLeftColor = brandColor + '88'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = rosterSubTab === sub && activeTab === tab.key ? brandColor + '22' : 'transparent'; e.currentTarget.style.color = rosterSubTab === sub && activeTab === tab.key ? '#fff' : 'rgba(255,255,255,0.5)'; e.currentTarget.style.borderLeftColor = rosterSubTab === sub && activeTab === tab.key ? brandColor : 'transparent'; }}
                      style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', letterSpacing: '1px', background: rosterSubTab === sub && activeTab === tab.key ? `${brandColor}22` : 'transparent', border: 'none', borderLeft: `2px solid ${rosterSubTab === sub && activeTab === tab.key ? brandColor : 'transparent'}`, color: rosterSubTab === sub && activeTab === tab.key ? '#fff' : 'rgba(255,255,255,0.5)', padding: '10px 18px', cursor: 'pointer', transition: 'left 0.12s, background 0.12s', textAlign: 'left', whiteSpace: 'nowrap' }}>
                      {sub}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Go-Home Banner — fixed under tab bar */}
      {isGoHomeWeek && (
        <div style={{ position: 'fixed', top: '92px', left: 0, right: 0, zIndex: 47, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', padding: '7px 24px', background: 'linear-gradient(90deg, rgba(0,0,0,0.95), rgba(20,10,0,0.97), rgba(0,0,0,0.95))', borderBottom: '2px solid rgba(230,126,34,0.7)' }}>
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(230,126,34,0.8)', letterSpacing: '2px' }}>🔥 GO-HOME SHOW — ROAD TO</div>
          {pleLogo && <img loading="lazy" src={pleLogo} alt="" style={{ height: '22px', objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(230,126,34,0.6))' }} onError={e => { e.target.style.display='none'; }} />}
          <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.6rem', letterSpacing: '2px', color: '#e67e22' }}>{pleData ? pleData.name.toUpperCase() : 'NEXT PLE'}</div>
        </div>
      )}

      {/* PLE Banner — fixed under tab bar */}
      {isPLEWeek && (
        <div style={{ position: 'fixed', top: '92px', left: 0, right: 0, zIndex: 47, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px', padding: '7px 24px', background: 'linear-gradient(90deg, rgba(0,0,0,0.95), rgba(5,3,0,0.97), rgba(0,0,0,0.95))', borderBottom: '2px solid ' + pleAccentColor + '88' }}>
          {pleLogo && <img loading="lazy" src={pleLogo} alt="" style={{ height: '28px', objectFit: 'contain', filter: 'drop-shadow(0 0 10px ' + pleAccentColor + '99)' }} onError={e => { e.target.style.display='none'; }} />}
          <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.75rem', letterSpacing: '3px', color: pleAccentColor }}>{pleData ? pleData.name.toUpperCase() : 'PREMIUM LIVE EVENT'}</div>
          {pleLogo && <img loading="lazy" src={pleLogo} alt="" style={{ height: '28px', objectFit: 'contain', filter: 'drop-shadow(0 0 10px ' + pleAccentColor + '99)' }} onError={e => { e.target.style.display='none'; }} />}
          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.44rem', color: 'rgba(255,255,255,0.3)', letterSpacing: '2px' }}>— PREMIUM LIVE EVENT —</div>
        </div>
      )}

      <div style={{ position: 'relative', zIndex: 6, display: 'flex', gap: '18px', padding: (isPLEWeek || isGoHomeWeek) ? '140px 24px 24px' : '104px 24px 24px', minHeight: '100vh' }}>

        {/* WIP tabs */}
        {activeTab !== 'home' && (
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            {activeTab === 'roster'
              ? <RosterTab
                key={rosterSubTab}
                gameData={gameData}
                brand={brand}
                onUpdateGameData={onUpdateGame}
                initialSection={({'CURRENT ROSTER': 'actual', 'RIVALRIES': 'rivalries', 'CHAMPIONSHIPS': 'championships', 'RECRUITMENT': 'recruitment'})[rosterSubTab] || null}
                confirmDestructive={confirmDestructive !== false}
              />
              : activeTab === 'booking'
              ? (week % 5 === 0
                ? <PLEBookingPage gameData={gameData} brand={brand} brandBg={brandBg || BRAND_BGS[brand]} onUpdateGame={onUpdateGame} onRunShow={() => setShowFlow(true)} />
                : <BookingPage gameData={gameData} brand={brand} brandBg={brandBg || BRAND_BGS[brand]} onUpdateGame={onUpdateGame} onRunShow={() => setShowFlow(true)} />)
              : activeTab === 'logistics'
              ? <LogisticsTab gameData={gameData} onBack={() => setActiveTab('home')} onUpdateGameData={onUpdateGame} />
              : activeTab === 'history'
              ? <HistoryTab gameData={gameData} brandColor={brandColor} onBack={() => setActiveTab('home')} />
              : activeTab === 'carriere'
              ? <CareerTab gameData={gameData} onUpdateGameData={onUpdateGame} />
              : (
                <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '16px' }}>
                  <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '2rem', letterSpacing: '4px', color: 'rgba(255,255,255,0.08)' }}>
                    {activeTab === 'logistics' ? 'LOGISTICS' : activeTab === 'carriere' ? 'CAREER' : 'HISTORY'}
                  </div>
                  <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.6rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '2px' }}>TO BE DEVELOPED</div>
                </div>
              )
            }
          </div>
        )}

        {/* ── LEFT COLUMN ── */}
        {/* Stop show confirmation modal */}
        {confirmStopShow && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}>
            <div style={{ background: 'rgba(14,14,14,0.98)', border: '1px solid rgba(255,255,255,0.12)', borderTop: '2px solid #e01010', borderRadius: '10px', padding: '28px 32px', maxWidth: '360px', width: '90%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ fontFamily: "'Anton',sans-serif", fontSize: '0.85rem', letterSpacing: '2px', color: '#fff' }}>STOP SHOW RESULTS?</div>
              <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.5rem', color: 'rgba(255,255,255,0.45)', lineHeight: '1.6' }}>
                Your current show results will be lost. Unsaved progress cannot be recovered.
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '4px' }}>
                <button onClick={() => setConfirmStopShow(false)}
                  style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '1px', background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.45)', padding: '9px 20px', borderRadius: '5px', cursor: 'pointer' }}>
                  CANCEL
                </button>
                <button onClick={() => { setConfirmStopShow(false); setShowFlow(false); setActiveTab('home'); }}
                  style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.48rem', letterSpacing: '1px', background: 'rgba(224,16,16,0.15)', border: '1px solid #e01010', color: '#e01010', padding: '9px 20px', borderRadius: '5px', cursor: 'pointer' }}>
                  QUIT
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Show Flow */}
      {showFlow && (
        <ShowFlow
          gameData={gameData}
          brandColor={brandColor}
          brandBg={brandBg}
          onClose={() => setShowFlow(false)}
          onFinishShow={(updatedGame) => {
            setShowFlow(false);
            setActiveTab('home');
            if (onUpdateGame) onUpdateGame(updatedGame);
            // Check if a Shake-Up should trigger
            // PLE weeks are 5, 10, 15, 20, 25, 30, 35, 40, 45 (excluding 50 which is end of season)
            // After playing the PLE, we move to week+1 (6, 11, 16, etc)
            // So we trigger shake-up if previous week was a PLE (current week % 5 === 1)
            const prevWeek = (updatedGame.week || 1) - 1;
            const wasPLEWeek = prevWeek > 0 && prevWeek % 5 === 0 && prevWeek < 50;
            const shakeUpAlreadyDone = !!updatedGame._shakeUpDone;
            
            if (updatedGame._endOfSeason) {
              setShowEndOfSeason(true);
            } else if (wasPLEWeek && !shakeUpAlreadyDone) {
              setShowShakeUp(true);
            } else {
              setShowWeekStart(true);
            }
          }}
        />
      )}

      {activeTab === 'home' && <>
        <div style={{ width: '270px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {/* GM Panel */}
          <div style={{ ...S.panel, overflow: 'hidden', position: 'relative', borderColor: `${brandColor}44` }}>
            {brandBg && <img loading="lazy" src={brandBg} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(4px) brightness(0.3)', zIndex: 0 }} />}
            <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at bottom, ${brandColor}33 0%, transparent 65%)`, zIndex: 1 }} />
            <div style={{ position: 'relative', zIndex: 2, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', overflow: 'hidden', height: '200px' }}>
              <img loading="lazy" src={gmRender || placeholder} alt={gm}
                style={{ height: '220px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.9))', marginBottom: '-8px' }} />
            </div>
            <div style={{ position: 'relative', zIndex: 2, padding: '8px 12px 12px', background: 'rgba(0,0,0,0.8)', borderTop: `1px solid ${brandColor}44`, textAlign: 'center' }}>
              {brandLogo && <img loading="lazy" src={brandLogo} alt={brand} style={{ height: '40px', objectFit: 'contain', marginBottom: '6px', filter: 'drop-shadow(0 1px 6px rgba(0,0,0,0.9))' }} />}
              <div style={{ ...S.anton, fontSize: '0.9rem', letterSpacing: '1.5px', color: '#fff' }}>{gm.toUpperCase()}</div>
              <div style={{ ...S.label, fontSize: '0.36rem', marginTop: '2px' }}>GENERAL MANAGER</div>
            </div>
          </div>

          {/* Week info */}
          <div style={{ ...S.panel, padding: '14px' }}>
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
              <div style={{ ...S.label, marginBottom: '4px' }}>CURRENT WEEK</div>
              <div style={{ ...S.anton, fontSize: '3rem', color: brandColor, lineHeight: 1 }}>{week}</div>
              <div style={{ ...S.mono, fontSize: '0.38rem', color: 'rgba(255,255,255,0.3)', marginTop: '2px' }}>/ 50</div>
            </div>
            <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)', margin: '8px 0' }} />
            {/* Week type badge */}
            <div style={{ textAlign: 'center', marginBottom: '8px' }}>
              <div style={{ display: 'inline-block', ...S.mono, fontSize: '0.55rem', letterSpacing: '1px', color: weekTypeInfo.color, border: `1px solid ${weekTypeInfo.color}55`, borderRadius: '3px', padding: '3px 8px' }}>
                {weekTypeInfo.label}
              </div>
            </div>
            <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)', margin: '8px 0' }} />
            {/* Countdowns */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ ...S.label, fontSize: '0.52rem' }}>GO-HOME</span>
                <span style={{ ...S.mono, fontSize: '0.72rem', color: weeksToGoHome <= 1 ? '#e67e22' : '#fff' }}>
                  {weeksToGoHome <= 0 ? 'THIS WEEK' : `${weeksToGoHome} weeks`}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ ...S.label, fontSize: '0.52rem' }}>{nextPLE === 50 ? 'WRESTLEMANIA' : 'PLE'}</span>
                <span style={{ ...S.mono, fontSize: '0.72rem', color: weeksLeft <= 1 ? '#9b59b6' : '#fff' }}>
                  {weeksLeft <= 0 ? 'THIS WEEK' : `${weeksLeft} weeks`}
                </span>
              </div>
            </div>
            {/* Progress bar */}
            <div style={{ marginTop: '10px' }}>
              <div style={{ ...S.label, fontSize: '0.36rem', marginBottom: '4px' }}>SEASON</div>
              <div style={{ height: '4px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', overflow: 'hidden' }}>
                <div style={{ height: '100%', width: `${(week / 50) * 100}%`, background: brandColor, borderRadius: '2px', transition: 'width 0.3s' }} />
              </div>
            </div>
          </div>

          {/* Run Show button */}
          {gameData && gameData.bookingFinished && (
            <button onClick={() => setShowFlow(true)}
              style={{ width: '100%', fontFamily: "'Anton',sans-serif", fontSize: '0.8rem', letterSpacing: '3px', background: brandColor + '18', border: '2px solid ' + brandColor, color: brandColor, padding: '14px', borderRadius: '8px', cursor: 'pointer', textShadow: '0 0 20px ' + brandColor + '88', boxShadow: '0 0 30px ' + brandColor + '22', flexShrink: 0 }}>
              ▶ RUN SHOW
            </button>
          )}

          {/* Next PLE */}
          {nextPleId && (() => {
            const pleData = PLES.find(p => p.id === nextPleId);
            if (!pleData) return null;
            return (
              <div style={{ ...S.panel, padding: '14px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', position: 'relative', overflow: 'hidden' }}>
                {pleBgUrl && <img loading="lazy" src={pleBgUrl} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(6px) brightness(0.25)', zIndex: 0 }} onError={e => { e.target.style.display = 'none'; }} />}
                <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', width: '100%' }}>
                  <div style={{ ...S.label, marginBottom: '2px' }}>NEXT PLE</div>
                  <img loading="lazy" src={getPLELogo(pleData.id)} alt={pleData.name}
                    style={{ width: '100%', maxHeight: '60px', objectFit: 'contain', filter: 'drop-shadow(0 0 12px rgba(212,175,55,0.4))' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                  <div style={{ ...S.anton, fontSize: '0.75rem', letterSpacing: '2px', color: '#d4af37', textAlign: 'center' }}>{pleData.name.toUpperCase()}</div>
                  <div style={{ ...S.mono, fontSize: '0.44rem', color: 'rgba(255,255,255,0.3)' }}>IN {weeksLeft} WEEK{weeksLeft > 1 ? 'S' : ''}</div>
                </div>
              </div>
            );
          })()}

          {/* Budget, Fans & HOF */}
          <div style={{ ...S.panel, padding: '14px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div>
              <div style={{ ...S.label, marginBottom: '3px' }}>BUDGET</div>
              <div style={{ ...S.anton, fontSize: '1.8rem', color: '#ffffff', letterSpacing: '1px' }}>{formatBudget(budget)}</div>
            </div>
            <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)' }} />

            {/* FANS — primary si victoryCriteria === 'fans' */}
            <div style={{ opacity: victoryCriteria === 'fans' ? 1 : 0.45 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '3px' }}>
                {victoryCriteria === 'fans' && <img loading="lazy" src={process.env.PUBLIC_URL + '/icons/star-full.png'} alt="" style={{ width: '11px', height: '11px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />}
                <div style={{ ...S.label }}>FANS</div>
              </div>
              <div style={{ ...S.anton, fontSize: victoryCriteria === 'fans' ? '1.8rem' : '1.1rem', color: '#ffffff', letterSpacing: '1px' }}>{formatFans(fans)}</div>
            </div>
            <div style={{ height: '1px', background: 'rgba(255,255,255,0.06)' }} />

            {/* HOF TROPHIES — primary si victoryCriteria !== 'fans' */}
            <div style={{ opacity: victoryCriteria !== 'fans' ? 1 : 0.45 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '3px' }}>
                {victoryCriteria !== 'fans' && <img loading="lazy" src={process.env.PUBLIC_URL + '/icons/star-full.png'} alt="" style={{ width: '11px', height: '11px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />}
                <div style={{ ...S.label }}>HOF TROPHIES</div>
              </div>
              <div style={{ ...S.anton, fontSize: victoryCriteria !== 'fans' ? '1.8rem' : '1.1rem', color: '#d4af37', letterSpacing: '1px' }}>{hofTrophies}</div>
              <div style={{ height: '3px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', overflow: 'hidden', marginTop: '4px' }}>
                <div style={{ height: '100%', width: `${Math.min((hofTrophies / hofGoal) * 100, 100)}%`, background: '#d4af37', borderRadius: '2px' }} />
              </div>
            </div>
          </div>
        </div>

        {/* ── CENTER ── */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '12px', minWidth: 0 }}>

          {/* Championships */}
          <div style={{ ...S.panel, padding: '14px 16px' }}>
            <div style={{ ...S.sectionTitle, marginBottom: '12px' }}>CHAMPIONSHIPS</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
              {champList.map(c => <ChampCard key={c.key} champ={c} brandColor={brandColor} />)}
            </div>
          </div>

          {/* Rivalries */}
          <div style={{ ...S.panel, padding: '14px 16px' }}>
            <div style={{ ...S.sectionTitle, marginBottom: '12px' }}>ACTIVE RIVALRIES</div>
            {rivalries.length === 0 ? (
              <div style={{ ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.2)', textAlign: 'center', padding: '16px 0' }}>— NO ACTIVE RIVALRIES —</div>
            ) : (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {rivalries.map((r, i) => <RivalryCard key={r.id || i} rivalry={r} roster={gameData && gameData.roster || []} brandColor={brandColor} />)}
              </div>
            )}
          </div>

          {/* Unavailable Superstars — injured + suspended + absent */}
          {(() => {
            var allRoster = (gameData && gameData.roster) || [];
            var unavailable = allRoster.filter(function(w) {
              var isInjured = w.injured && w.injuryWeeksLeft > 0;
              var isSuspended = w.suspended && w.suspensionWeeksLeft > 0;
              var isAbsent = w.absent && w.suspensionWeeksLeft > 0;
              return isInjured || isSuspended || isAbsent;
            });
            if (unavailable.length === 0) return null;

            var getStatus = function(w) {
              if (w.injured && w.injuryWeeksLeft > 0) return { label: '🤕 INJURED', color: '#e74c3c', weeks: w.injuryWeeksLeft };
              if (w.absent && w.suspensionWeeksLeft > 0) return { label: '🏥 UNAVAILABLE', color: '#1abc9cd9', weeks: w.suspensionWeeksLeft };
              if (w.suspended && w.suspensionWeeksLeft > 0) return { label: '🚫 SUSPENDED', color: '#9b59b6', weeks: w.suspensionWeeksLeft };
              return null;
            };

            return (
              <div style={{ ...S.panel, padding: '14px 16px', border: '1px solid rgba(231,76,60,0.2)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                  <div style={{ ...S.sectionTitle }}>UNAVAILABLE SUPERSTARS</div>
                  <div style={{ ...S.mono, fontSize: '0.42rem', color: 'rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '3px', padding: '1px 7px' }}>{unavailable.length}</div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {unavailable.map(function(w) {
                    var status = getStatus(w);
                    if (!status) return null;
                    var barMax = w.injured ? 12 : 8;
                    var barPct = Math.min((status.weeks / barMax) * 100, 100);
                    return (
                      <div key={w.wrestler_id} style={{ width: '130px', height: '180px', overflow: 'hidden', position: 'relative', flexShrink: 0, borderRadius: '12px', background: status.color + '0a', border: '1px solid ' + status.color + '33' }}>
                        {/* Render */}
                        <img loading="lazy" src={getWrestlerRender(w) || placeholder} alt=""
                          style={{ width: '100%', height: '140px', objectFit: 'contain', objectPosition: 'top', filter: 'grayscale(0.6) drop-shadow(0 4px 14px rgba(0,0,0,0.9))', display: 'block' }} />
                        {/* Status tag top-left */}
                        <div style={{ position: 'absolute', top: '5px', left: '5px', background: status.color + '22', border: '1px solid ' + status.color + '66', borderRadius: '3px', padding: '1px 5px' }}>
                          <div style={{ fontFamily: "'Monda',sans-serif", fontSize: '0.3rem', color: status.color, letterSpacing: '0.5px', whiteSpace: 'nowrap' }}>{status.label}</div>
                        </div>
                        {/* Bottom info */}
                        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.88)', padding: '5px 8px' }}>
                          <div style={{ ...S.anton, fontSize: '0.5rem', color: '#fff', letterSpacing: '1px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getWrestlerNameUpper(w, 'display')}</div>
                          <div style={{ ...S.mono, fontSize: '0.4rem', color: status.color, textAlign: 'center', marginTop: '1px' }}>{status.weeks} wk{status.weeks > 1 ? 's' : ''} remaining</div>
                          <div style={{ height: '3px', background: 'rgba(255,255,255,0.08)', borderRadius: '2px', overflow: 'hidden', marginTop: '4px' }}>
                            <div style={{ height: '100%', width: barPct + '%', background: status.color, borderRadius: '2px', transition: 'width 0.3s' }} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Last week summary */}
          <div style={{ ...S.panel, padding: '14px 16px', flex: 1 }}>
            <div style={{ ...S.sectionTitle, marginBottom: '12px' }}>
              WEEK {week > 1 ? week - 1 : '—'} - SUMMARY
            </div>
            {week === 1 ? (
              <div style={{ ...S.mono, fontSize: '0.52rem', color: 'rgba(255,255,255,0.2)', textAlign: 'center', padding: '20px 0' }}>
                No show played yet.
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    {['MATCH', 'RESULT', 'RATING'].map(h => (
                      <th key={h} style={{ ...S.label, fontSize: '0.68rem', padding: '10px 12px', textAlign: 'left', fontWeight: 'normal' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {lastWeekMatches.map((m, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)', background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent' }}>
                      <td style={{ ...S.mono, fontSize: '0.78rem', color: 'rgba(255,255,255,0.7)', padding: '10px 10px' }}>{m.match}</td>
                      <td style={{ ...S.mono, fontSize: '0.78rem', color: m.result ? '#2ecc71' : 'rgba(255,255,255,0.25)', padding: '10px 10px' }}>{m.result || '—'}</td>
                      <td style={{ padding: '8px 8px' }}>
                        {m.note ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {[...Array(5)].map((_, si) => (
                              <div key={si} style={{ width: '8px', height: '8px', borderRadius: '50%', background: si < m.note ? '#d4af37' : 'rgba(255,255,255,0.1)' }} />
                            ))}
                          </div>
                        ) : <span style={{ ...S.mono, fontSize: '0.72rem', color: 'rgba(255,255,255,0.2)' }}>—</span>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* ── RIGHT COLUMN ── */}
        <div style={{ width: '280px', flexShrink: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>

          {/* Rival GMs */}
          {rivals && rivals.filter(Boolean).length > 0 && (
            <div style={{ ...S.panel, padding: '12px 14px' }}>
              <div style={{ ...S.sectionTitle, marginBottom: '10px' }}>RIVAL GMs</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {rivals.filter(Boolean).map((rival, i) => {
                  const rBrandLogo = BRAND_LOGOS[rival.brand] || rival.brandLogo || null;
                  const rBrandColor = BRAND_COLORS[rival.brand] || rival.brandColor || '#444';
                  const rGMRender = GM_RENDERS[rival.gm] || rival.gmRender || null;
                  // Rival HOF trophies count
                  var rivalHofCount = (rival.hofActive || []).length;
                  
                  var updateRivalTrophies = function(delta) {
                    var newRivals = (gameData.rivals || []).map(function(rv, idx) {
                      if (idx !== i) return rv;
                      var current = (rv.hofActive || []).slice();
                      if (delta > 0) {
                        current.push('manual_' + Date.now());
                      } else if (delta < 0 && current.length > 0) {
                        current.pop();
                      }
                      return { ...rv, hofActive: current };
                    });
                    if (onUpdateGame) onUpdateGame({ ...gameData, rivals: newRivals });
                  };
                  
                  return (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '0 10px 0 0', background: `${rBrandColor}11`, border: `1px solid ${rBrandColor}33`, borderRadius: '8px', overflow: 'hidden' }}>
                      {/* GM render */}
                      <div style={{ width: '52px', height: '70px', flexShrink: 0, overflow: 'hidden', position: 'relative' }}>
                        <img loading="lazy" src={rGMRender || placeholder} alt={rival.gm}
                          style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', height: '80px', objectFit: 'contain', objectPosition: 'top', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.9))' }} />
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {rBrandLogo && <img loading="lazy" src={rBrandLogo} alt={rival.brand} style={{ height: '18px', objectFit: 'contain', marginBottom: '3px', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.8))' }} />}
                        <div style={{ ...S.anton, fontSize: '0.55rem', letterSpacing: '1px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{rival.gm ? rival.gm.toUpperCase() : '—'}</div>
                        <div style={{ ...S.mono, fontSize: '0.38rem', color: rBrandColor, letterSpacing: '1px', marginTop: '1px' }}>{rival.brand}</div>
                      </div>
                      {/* HOF trophy controls */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                        <button onClick={() => updateRivalTrophies(-1)} 
                          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)', color: '#d4af37', width: '18px', height: '18px', borderRadius: '3px', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>−</button>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px', minWidth: '32px', justifyContent: 'center' }}>
                          <img loading="lazy" src={process.env.PUBLIC_URL + '/hof/trophy.png'} alt="HOF" style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                          <div style={{ ...S.anton, fontSize: '0.7rem', color: '#d4af37' }}>{rivalHofCount}</div>
                        </div>
                        <button onClick={() => updateRivalTrophies(1)} 
                          style={{ background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)', color: '#d4af37', width: '18px', height: '18px', borderRadius: '3px', cursor: 'pointer', fontSize: '0.7rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0 }}>+</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Classement */}
          <div style={{ ...S.panel, padding: '14px' }}>
            <div style={{ ...S.sectionTitle, marginBottom: '2px' }}>STANDINGS</div>
            <div style={{ ...S.label, fontSize: '0.52rem', marginBottom: '12px' }}>
              {victoryCriteria === 'fans' ? 'BASED ON FANS' : 'BASED ON HOF TROPHIES'}
            </div>

            {/* Build sorted ranking */}
            {(() => {
              var entries = [
                { isPlayer: true, gm: gm || 'Vous', brand, logo: brandLogo, color: brandColor,
                  fans: fans, trophies: hofTrophies,
                  value: victoryCriteria === 'fans' ? fans : hofTrophies },
                ...(rivals || []).filter(Boolean).map(r => {
                  var rHofActive = r.hofActive || [];
                  var rFans = r.fans || 0;
                  var rProfits = r.totalProfits || 0;
                  var rAutoFan = AUTO_FAN_THRESHOLDS.filter(function(t) { return rFans >= t; }).length;
                  var rAutoProfit = AUTO_PROFIT_THRESHOLDS.filter(function(t) { return rProfits >= t; }).length;
                  var rTrophies = rHofActive.length + rAutoFan + rAutoProfit;
                  return {
                    isPlayer: false, gm: r.gm || '—', brand: r.brand, logo: BRAND_LOGOS[r.brand] || r.brandLogo || null,
                    color: BRAND_COLORS[r.brand] || r.brandColor || '#444',
                    fans: rFans, trophies: rTrophies,
                    value: victoryCriteria === 'fans' ? rFans : rTrophies,
                  };
                })
              ].sort(function(a, b) {
                var primary = b.value - a.value;
                if (primary !== 0) return primary;
                // Tie-breaker : critère secondaire
                return victoryCriteria === 'fans' ? (b.trophies - a.trophies) : (b.fans - a.fans);
              });

              var starIcon = process.env.PUBLIC_URL + '/icons/star-full.png';

              return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {entries.map((entry, rank) => (
                    <div key={rank} style={{ ...S.panel, padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '8px', borderColor: entry.isPlayer ? entry.color + '55' : 'rgba(255,255,255,0.08)', background: entry.isPlayer ? entry.color + '11' : 'transparent' }}>
                      <div style={{ ...S.anton, fontSize: '0.9rem', color: entry.isPlayer ? entry.color : 'rgba(255,255,255,0.4)', width: '18px', textAlign: 'center' }}>{rank + 1}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {entry.logo ? (
                          <img loading="lazy" src={entry.logo} alt={entry.brand} style={{ height: '20px', objectFit: 'contain', marginBottom: '2px', display: 'block' }} />
                        ) : (
                          <div style={{ ...S.anton, fontSize: '0.6rem', letterSpacing: '1px', color: entry.color, marginBottom: '2px' }}>{(entry.brand || '').toUpperCase()}</div>
                        )}
                        <div style={{ ...S.mono, fontSize: entry.isPlayer ? '0.6rem' : '0.5rem', color: entry.isPlayer ? '#fff' : 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{entry.gm}</div>
                      </div>
                      {/* Deux compteurs — primary en avant, secondary discret */}
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '3px' }}>
                        {/* FANS */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px', opacity: victoryCriteria === 'fans' ? 1 : 0.4 }}>
                          {victoryCriteria === 'fans' && <img loading="lazy" src={starIcon} alt="" style={{ width: '9px', height: '9px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />}
                          <div style={{ ...S.anton, fontSize: victoryCriteria === 'fans' ? '0.85rem' : '0.6rem', color: '#ffffff' }}>
                            {formatFans(entry.fans)}
                          </div>
                        </div>
                        {/* HOF */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '3px', opacity: victoryCriteria !== 'fans' ? 1 : 0.4 }}>
                          {victoryCriteria !== 'fans' && <img loading="lazy" src={starIcon} alt="" style={{ width: '9px', height: '9px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />}
                          <div style={{ ...S.anton, fontSize: victoryCriteria !== 'fans' ? '0.85rem' : '0.6rem', color: '#d4af37' }}>
                            {entry.trophies}
                          </div>
                          <img loading="lazy" src={process.env.PUBLIC_URL + '/hof/trophy.png'} alt="" style={{ width: '22px', height: '22px', objectFit: 'contain', filter: 'drop-shadow(0 0 4px rgba(212,175,55,0.5))' }} onError={e => { e.target.style.display='none'; }} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>

          {/* Logistics summary */}
          {(() => {
            const log = gameData && gameData.logistics || { arena: 1, crew: 1, sfx: 1, advertising: 1 };
            const tokens = gameData?.logisticsTokens || 0;
            const LOGISTICS_NAMES = {
              arena:       ['High School','Concert Hall','Wrestling Center','Classic Arena','Stadium','Grand Stadium'],
              crew:        ['Touring Crew','Backstage Crew','Gorilla Crew','Stage Crew','Expert Crew','Veteran Crew','Immortal Crew'],
              sfx:         ['Basic Effects','Smoke Effects','Pyrotechnics','Advanced Effects','Pro Effects','Premium Effects','Cutting-Edge Effects'],
              advertising: ['Local Boards','E-Mail Campaign','Advertising','Social Media','Stable Campaign','Viral Marketing','Global Advertising'],
            };
            const rows = [
              { key: 'arena',       label: 'ARENA' },
              { key: 'sfx',         label: 'EFFECTS' },
              { key: 'crew',        label: 'CREW' },
              { key: 'advertising', label: 'ADS' },
            ];
            return (
              <div style={{ ...S.panel, padding: '14px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ ...S.sectionTitle }}>LOGISTICS</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', ...S.mono, fontSize: '0.5rem', color: '#f1c40f', background: 'rgba(241,196,15,0.1)', border: '1px solid rgba(241,196,15,0.3)', borderRadius: '4px', padding: '3px 8px', letterSpacing: '1px' }}>
                    <img loading="lazy" src={process.env.PUBLIC_URL + '/logistics/asset_token.png'} alt="" style={{ width: '14px', height: '14px', objectFit: 'contain' }} onError={e => { e.target.style.display='none'; }} />
                    {tokens} TOKEN{tokens !== 1 ? 'S' : ''}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                  {rows.map(({ key, label }) => {
                    const rank = log[key] || 1;
                    const name = LOGISTICS_NAMES[key][rank - 1] || '';
                    return (
                      <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px' }}>
                        <span style={{ ...S.label, fontSize: '0.48rem', flexShrink: 0 }}>{label}</span>
                        <span style={{ ...S.mono, fontSize: '0.5rem', color: 'rgba(255,255,255,0.55)', textAlign: 'right' }}>
                          <span style={{ color: brandColor, fontFamily: "'Anton',sans-serif", fontSize: '0.55rem' }}>R{rank}</span>
                          {' '}/ {name}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })()}

          {/* Settings recap */}
          <div style={{ ...S.panel, padding: '14px' }}>
            <div style={{ ...S.sectionTitle, marginBottom: '10px' }}>SETTINGS</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {[
                { label: 'DIFFICULTY', value: (gameData?.difficulty || gameData?.gameSettingsData?.difficulty || 'normal').toUpperCase() },
                { label: 'INITIAL BUDGET', value: formatBudget(gameData?.budget || gameData?.gameSettingsData?.budget || 3000000) },
                { label: 'MATCH TYPE', value: (gameData?.matchType || gameData?.gameSettingsData?.matchType || 'classic') === 'classic' ? 'Classic' : 'Unlockable' },
                { label: 'HOF GOAL', value: `${hofGoal} trophies` },
                { label: 'VICTORY BY', value: victoryCriteria === 'fans' ? 'Fans' : 'Trophies' },
              ].map(({ label, value }) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ ...S.label, fontSize: '0.52rem' }}>{label}</span>
                  <span style={{ ...S.mono, fontSize: '0.6rem', color: 'rgba(255,255,255,0.6)' }}>{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </> }
      </div>
    </div>
  );
}
